<script lang="ts">
  import type { Snippet } from 'svelte';
  import { captureException } from '$lib/sentry';
  let { children }: { children: Snippet } = $props();
</script>

<svelte:boundary
  onerror={(e) => {
    console.error('App error:', e);
    captureException(e);
  }}
>
  {@render children()}

  {#snippet failed(error, reset)}
    <div class="error-page">
      <h1>Something went wrong</h1>
      <p>{(error as Error)?.message || 'An unexpected error occurred.'}</p>
      <button class="btn btn-primary" onclick={reset}>Try Again</button>
    </div>
  {/snippet}
</svelte:boundary>

<style>
  .error-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100dvh;
    padding: 1rem;
    text-align: center;
  }
  .error-page h1 {
    color: var(--error);
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }
  .error-page p {
    color: var(--text-secondary);
    margin-bottom: 1rem;
  }
</style>
